import {
  bodyGroup,
  bodyGroupAdd,
  bodyGroupEdit,
  bodyGroupRemove,
} from "../../../services/BodyParts/bodyGroup.service.";
import { types } from "../types";

const isSuccessResponse = (response) => {
  const hasStatusTrue = response?.status === true;
  const hasSuccessStatusCode = response?.statusCode >= 200 && response?.statusCode < 300;
  console.log("Success check:", {
    hasStatusTrue,
    hasSuccessStatusCode,
    statusCode: response?.statusCode,
    status: response?.status,
    response
  });
  return hasStatusTrue || hasSuccessStatusCode;
};

export const bodyGroupInsert = (data) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  console.log("bodyGroupInsert data:", data);
  const response = await bodyGroupAdd(data);
  console.log("bodyGroupInsert response:", response);
  if (isSuccessResponse(response)) {
    const result = response.data;
    console.log("bodyGroupInsert response?.data:", response?.data);
    console.log("bodyGroupInsert result:", result);
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error || response.message };
  }
};

export const bodyGroupList = (data) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await bodyGroup(data);
  console.log("bodyGroupList response:", response);
  console.log("bodyGroupList data:", data);
  if (isSuccessResponse(response)) {
    console.log("bodyGroupList isSuccessResponse:", isSuccessResponse(response));
    const result = response?.data?.data;
    console.log("bodyGroupList response?.data:", response?.data);
    console.log("bodyGroupList result:", result);
    dispatch({ type: types.BODY_GROUP_LIST, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.BODY_GROUP_LIST,
      payload: [],
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error || response.message };
  }
};

export const bodyGroupUpdate = (data) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  console.log("bodyGroupUpdate data:", data);
  const response = await bodyGroupEdit(data);
  console.log("bodyGroupUpdate response:", response);
  console.log("bodyGroupUpdate response keys:", Object.keys(response || {}));
  console.log("Response analysis:", {
    status: response?.status,
    statusCode: response?.statusCode,
    data: response?.data,
    error: response?.error,
    success: response?.success
  });
  if (isSuccessResponse(response)) {
    const result = response.data;
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error || response.message };
  }
};

export const bodyGroupDelete = (id) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  console.log("bodyGroupDelete id:", id);
  const response = await bodyGroupRemove(id);
  console.log("bodyGroupDelete response:", response);
  if (isSuccessResponse(response)) {
    const result = response.data;
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error || response.message };
  }
};
